import { render } from "./createwallet.vue?vue&type=template&id=625de034&scoped=true"
import script from "./createwallet.vue?vue&type=script&lang=js"
export * from "./createwallet.vue?vue&type=script&lang=js"

import "./createwallet.vue?vue&type=style&index=0&id=625de034&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625de034"]])

export default __exports__